/**
 * TMMPDM-0113: the merchant-knowledge routes (`/v1/admin/merchant-patterns…`, `/v1/admin/naming-quality`,
 * `/v1/admin/institution-requests…`) are vendored from tmm-api `f7c843fb`, blob
 * `f2a3324a3ea15f9fd036f87de0401cbfdee9b7ee` (TMMAPI-0194 and TMMAPI-0195 shipped; TMMPDM-0112 called
 * them from their specs at `9ae13265`). The paths, the query and the bodies are as TMMPDM-0112 called
 * them (the TMMPDM-0113 delivery's Step 0 table). Until tmm-api deploys them they answer a bare 404. No
 * other route changed: the rest stays pinned to `3a2d9f5f`.
 * tmm-api contract vendored from tmm-api `3a2d9f5f`, blob `15d368c4a0a14f32559481bce26dfcdce4a7b17e` (the same pin as
 * `types.ts`; TMMPDM-0111). TMMAPI-0181 U5 has shipped (`4f100e18`): the ticket and announcement routes
 * below are now in the YAML, by the paths, bodies and codes the console already called (the TMMPDM-0111
 * delivery's Step 0 table). No other route this console calls changed.
 * TMMPDM-0110 pinned `56a8fa38`, blob `1b9016c0868d2bf479064f5d6a3ec928922d7d40` (the same pin as
 * `types.ts`; TMMPDM-0110). No admin route changed. TMMAPI-0181's spec at `56a8fa38` (blob
 * `5ab13d521d2161ca0be14829c03608d087ceece9`) fixes the ticket routes as TMMPDM-0109 calls them (item
 * 30: the bare integer `{number}` on every route, `TICKET_NOT_FOUND` for a missing one). The
 * announcement routes (`/v1/admin/announcements…`, item 32a) and the ticket attachment read
 * (`GET /v1/admin/tickets/{number}/attachments/{id}`, U7 item 46) are called from that spec too;
 * where it names an operation but not its path or body, the choice is the console's, recorded in the
 * TMMPDM-0110 delivery. Until tmm-api deploys them they answer a bare 404.
 * TMMPDM-0109 pinned `355a1eb3`, blob `f04045f7227d54a0fb067d5bc634b468748b6925` (the same pin as
 * `types.ts`; TMMPDM-0109). No route this console already calls changed. The ticket routes
 * (`/v1/admin/tickets…`) are called from tmm-api's SPEC, TMMAPI-0181 at `355a1eb3`, blob
 * `6b0978edb22737f84d16f2ddc49bc23ff18c6e60` (U5 items 28–31), ahead of U5's merge: the spec names the
 * operations, and their paths and bodies are the console's choice, recorded in the TMMPDM-0109
 * delivery. Until tmm-api deploys U5 they answer a bare 404 (`NOT_FOUND`: no such route); a deployed
 * route's missing ticket is `TICKET_NOT_FOUND`.
 * TMMPDM-0108 pinned `c3e9d5f4`, blob `fe19ae979bae874185e9eee627be545b34998725` (the same pin as
 * `types.ts`; TMMPDM-0108). 0174 changes no route path or body this console sends: the add may answer
 * 409 `AI_MODEL_NOT_SUPPORTED` with reason `NO_STRUCTURED_OUTPUT`, Verify also updates
 * `structuredOutputs`, and the assignment POST refuses a model whose `structuredOutputs` is false
 * (and, per 0176 item 11, unknown) with 400 `fields.model`.
 * TMMPDM-0105 pinned `a003886d` (origin/main after the TMMAPI-0172 ship), blob
 * `5850028bf30e4335c806ca8f66130a679298b37b`. 0172 changes
 * no route path or body this console sends: the add may answer 409 `AI_MODEL_NOT_SUPPORTED`, and
 * the assignment POST checks `effort` against the model's `efforts` and refuses an Anthropic-retired
 * model. TMMPDM-0104 pinned `12513dae` (origin/main after the TMMAPI-0171 ship), blob
 * `ef127fbce5c846c74aabe31afb634531a41a163f`. 0171 adds the AI model catalogue routes (`/v1/admin/ai-models`, `PATCH`/`DELETE
 * /{id}`, `POST /{id}/verify`); the assignment POST takes `effort`. No other route this console
 * calls changed. The catalogue PATCH may send `note: null` (clears it); no other body sends `null`.
 * TMMPDM-0102 pinned `40bf78af` (origin/main at that re-pin),
 * blob `eda057ac29c8b19ab94771a0d37f63566d56766a` (api/openapi.yaml at main; the same pin as
 * `types.ts`; it carries the TMMAPI-0167 ship `f26b926a`). 0167 changes request bodies only: no
 * route and no response shape this console calls changed. tmm-api applies an admin PATCH/PUT field
 * only when it is non-null, so no body here sends `null` (TMMPDM-0102).
 * TMMPDM-0101 pinned `cd80708` / blob `03dec427ca2f2de4af791dd2dcfef09ea376111e` (the TMMAPI-0165
 * ship `26b93ffb`). Part B (model assignment, price withdraw) is on that YAML. The POST bodies
 * omit `effectiveFrom` for Now and `note` when empty, and the tab re-reads the GET. TMMPDM-0098
 * first called these from the 0165 spec at `1fa01dd5`.
 * The ledger reads and actions stay under `/v1/admin/partners/{payeeRef}/ledger`,
 * and the cut-over under `/v1/admin/billing/ledger/`. A bare 404 (no `*_NOT_FOUND` code) is still
 * "not available yet"; a deployed route's 404 is `PAYEE_NOT_FOUND`, `STATEMENT_NOT_FOUND` or
 * `HOLD_NOT_FOUND`. TMMPDM-0095 first called these from the 0162 spec at `c09f02b5`; TMMPDM-0096
 * re-pinned that spec (not the YAML) to `a1b8cad7`. TMMPDM-0094: `backfillPayees`
 * (`POST /v1/admin/billing/payees/backfill`, 0161). TMMPDM-0093: `declareSkus`
 * (`POST /v1/admin/billing/skus/declare`, 0159); `eraseDeletionNow` retries a `FAILED` request
 * (0158, no shape change). TMMPDM-0092: `eraseDeletionNow`
 * (`POST …/deletion-requests/{id}/erase-now`, 0157); the seller and terms settings use the
 * existing product-settings routes. TMMPDM-0091: the card's tax routes are
 * gone (tmm-api calculates no tax, MM-D-139); 0157's new routes are not called. TMMPDM-0090: no
 * route changed; card create takes `controls`, the worksheet answers the customer's `bill`.
 * TMMPDM-0089: our wholesale card routes (`/v1/admin/billing/rate-cards/**`) are gone; the margin
 * worksheet and the per-currency processing fees are new. The 0153 schedule POSTs answer the whole
 * envelope.
 * TMMPDM-0084: `provisionTenantBilling` (`POST …/billing/provision`).
 * Transfer and card-assignment calls are retired; activation replaces the active card.
 * tmm-api product-admin client (TMMPDM-0006). Every path is under
 * `TMM_API_PREFIX` (`/v1/admin/`), so `src/api/client.ts` already routes it
 * same-origin to `/api`, bearer-only, uncredentialed, no CSRF. tmm-api
 * answers raw DTOs — no `{success,data}` envelope (contrast `../saas/*`).
 * A tenant slug travels only as the addressed resource in a path or query;
 * product scope is server-derived from the token.
 *
 * TMMPDM-0017 (MM-D-101, TMMAPI-0074): the tenant roster/detail and the reseller + GHL
 * business operations live here too. tmm-api calls saas-auth server-to-server and passes the
 * reseller/GHL DTOs through unwrapped; a write it could not confirm answers 502
 * `SAAS_AUTH_OUTCOME_UNKNOWN` — callers re-read, never re-POST (`isOutcomeUnknown`).
 *
 * TMMPDM-0018: a tenant's whitelabel domain and a reseller's GHL diagnose, same pass-through. The
 * two slow live checks carry a per-call `timeout` longer than tmm-api's own (handoff §5): verify
 * 65 s, diagnose 25 s. Everything else keeps the factory default.
 *
 * TMMPDM-0019: the add-on catalogue, the fleet add-on list and a tenant's add-ons (TMMAPI-0039).
 *
 * TMMPDM-0020: per-currency dashboard/revenue, resellerId filters, patchTenant,
 * product settings. Tenant agreement GET/POST deleted (410).
 *
 * TMMPDM-0021: reseller agreement GET/POST, one-call `createTenant` (25 s timeout; identical-body
 * retry is safe after timeout / 502 / TENANT_SETUP_INCOMPLETE), reseller payouts. `completeTenantCreate`
 * removed.
 *
 * TMMPDM-0022: reseller standing GET; transfer-tenants and deactivate POSTs (resumable —
 * identical-body Finish is safe; 502 `SAAS_AUTH_OUTCOME_UNKNOWN` → re-read, never auto re-POST).
 *
 * TMMPDM-0025 (TMMAPI-0084/0087/0089): standing clear, reseller brand create (25 s; 200 and 201
 * alike; 502 outcome-unknown → re-read, never re-POST), and the GHL save's proof of control (35 s).
 *
 * TMMPDM-0026 (TMMAPI-0090): reseller reactivate (502 outcome-unknown → re-read, never re-POST).
 *
 * TMMPDM-0032 (TMMAPI-0097, MM-D-105): a reseller's own rate cards (list, create — an empty body
 * copies the agreement card — preview, get, patch a DRAFT, activate, close, copy) and the tenant's
 * rate-card assignment. The tenant pricing read is gone (410 `PRICING_MOVED_TO_RATE_CARDS`).
 * Tenant create / PATCH / reseller assignment may answer 502 `UPSTREAM_UNAVAILABLE` (TMMAPI-0096):
 * nothing was written, so the caller offers Try again with the identical body.
 *
 * TMMPDM-0037 (TMMAPI-0098…0101, MM-D-105): a reseller's card on file (read-only; the JSON `null`
 * body when it has none), its charges and the retry of a failed one, and its monthly settlements.
 * Standing clear is allowed from `PROBATION` too; reseller-card activation makes no pay-api call.
 *
 * TMMPDM-0041 (TMMAPI-0102/0104, MM-D-106): a reseller's affiliate commission plans (list, create —
 * an empty body is the default draft — preview, get, patch a DRAFT, activate, close, copy), acting on
 * the reseller's behalf. Standing clear answers 409 `RESELLER_SUSPENDED_USE_REACTIVATE` for a
 * reseller saas-auth holds suspended; TMMAPI-0119 narrows reactivate to the published
 * `reactivateOffered` cases and publishes the server-side standing list filter.
 *
 * TMMPDM-0042 (TMMAPI-0106): read an affiliate, its agreement, referrals and codes, and pause,
 * resume, end for cause or release the review hold. The per-reseller list is read-only.
 */
import { api } from '../client';
import { ApiError } from '../errors';
import type {
  LedgerAdjustmentRequest,
  LedgerCutoverView,
  LedgerHoldRequest,
  LedgerLinePage,
  LedgerManualPaymentRequest,
  LedgerOpeningView,
  LedgerStatementPage,
  LedgerStatementView,
  LedgerVoidRequest,
  PartnerLedgerView,
  AffiliateAgreementHistory,
  AffiliateCauseRequest,
  AffiliateCodeList,
  AffiliateDetail,
  AffiliateEarnings,
  AffiliateList,
  AffiliateListQuery,
  AffiliateReferralList,
  AffiliateReferralQuery,
  AddonCancelRequest,
  AddonWaiveRequest,
  AdminCancelRequest,
  AdminChangeOfferRequest,
  AdminCompRequest,
  AdminDeletionList,
  AdminDeletionRequest,
  AdminInvitationRequest,
  AdminInvitationResponse,
  AdminSeatList,
  AdminStatementList,
  AdminSubscribeRequest,
  AdminSubscribeResponse,
  AdminSubscriptionDetail,
  AdminSubscriptionList,
  AdminSubscriptionRow,
  AdminWaiveRequest,
  AdminAiCreditRequest,
  AdminAiCreditResponse,
  AiCostReconciliationList,
  AiCostReconciliationQuery,
  AdminWorksheet,
  CardControlsEnvelope,
  PlatformAiControlsEnvelope,
  ProcessingFeeRatesView,
  ProcessingFeeRateWrite,
  SettingWrite,
  WorksheetRequest,
  AiModelAssignmentWrite,
  AiModelAssignmentsView,
  AiModelCatalogAddRequest,
  AiModelCatalogList,
  AiModelCatalogPatchRequest,
  AiModelCatalogRow,
  AiModelPriceCreateRequest,
  AiModelPriceListResponse,
  AiModelPriceRow,
  AiSuspensionRequest,
  AiSuspensionResponse,
  AiUsageQuery,
  ApplyPromotionRequest,
  BillingAttention,
  CancelResponse,
  CatalogList,
  CatalogPatchRequest,
  CatalogView,
  CatalogWriteRequest,
  ChargeView,
  CommissionPlanList,
  CommissionPlanPreview,
  CommissionPlanPreviewRequest,
  CommissionPlanView,
  CommissionPlanWriteRequest,
  CreateResellerRequest,
  DashboardQuery,
  DeletionRequestView,
  ImmediateErasureView,
  FleetDashboard,
  OfferList,
  OfferRequest,
  ParkedEventNoteRequest,
  ParkedEventsQuery,
  ParkedFeedEventPage,
  ParkedFeedEventView,
  PayeeBackfillResult,
  PayoutRequest,
  PayoutStatementList,
  PayoutStatementView,
  PayoutStatus,
  ProductSettingsView,
  PromotionList,
  PutWhitelabelDomainRequest,
  ResellerAffiliateList,
  ResellerAgreementList,
  ResellerAgreementNotesRequest,
  ResellerAgreementView,
  ResellerAgreementWriteRequest,
  ResellerBillingCard,
  CustomerRateCardCreateRequest,
  CustomerRateCardList,
  CustomerRateCardMoveResult,
  CustomerRateCardPatchRequest,
  CustomerRateCardVersionView,
  CustomerRateCardVersionWrite,
  CustomerRateCardView,
  GrantedCustomerRateCardView,
  ResellerCharge,
  ResellerChargeList,
  ResellerDto,
  ResellerGhlIntegrationDiagnosisDto,
  ResellerGhlIntegrationDto,
  AdminTenantBillingState,
  ResellerListQuery,
  ResellerNoticeList,
  ResellerPage,
  ResellerReactivateRequest,
  ResellerStandingClearRequest,
  ResellerStandingView,
  RevenueQuery,
  RevenueReport,
  RunSheet,
  ScopedBillingClientConfig,
  SeatListQuery,
  SettlementQuery,
  SkuDeclarations,
  StatementListQuery,
  StatementView,
  SubscriptionListQuery,
  TenantAddonList,
  TenantAddonStatus,
  TenantAddonView,
  TenantCreateRequest,
  TenantList,
  TenantListQuery,
  TenantPatchRequest,
  TenantView,
  AnnouncementListQuery,
  AnnouncementPage,
  AnnouncementPublishRequest,
  AnnouncementView,
  AnnouncementWrite,
  CatalogInstitution,
  InstitutionAddRequest,
  InstitutionRequestList,
  MerchantPatternApproveRequest,
  MerchantPatternListQuery,
  MerchantPatternPage,
  MerchantPatternRejectRequest,
  NamingQualityQuery,
  NamingQualityReport,
  TicketDuplicateRequest,
  TicketListQuery,
  TicketPage,
  TicketShippedInRequest,
  TicketStatusRequest,
  TicketUpdateRequest,
  TicketView,
  UpdateResellerRequest,
  UpsertResellerGhlRequest,
  UsageReport,
  WhitelabelDomainDto,
  WhitelabelTemplateDto,
  WhitelabelVerifyResponse,
} from './types';

/** tmm-api waits up to 60 s for saas-auth's DNS checks; the client waits longer (handoff §5). */
const WHITELABEL_VERIFY_TIMEOUT_MS = 65_000;
/** tmm-api waits up to 20 s for the two live GHL probes; the client waits longer (handoff §5). */
const GHL_DIAGNOSE_TIMEOUT_MS = 25_000;
/** One-call tenant create: saas-auth + tmm setup; client waits ≥ 25 s (TMMAPI-0076 / TMMPDM-0021). */
const TENANT_CREATE_TIMEOUT_MS = 25_000;
/** Reseller brand create: saas-auth copies the product brand; client waits ≥ 25 s (TMMAPI-0087). */
const RESELLER_BRAND_TIMEOUT_MS = 25_000;
/** The GHL save proves control with GHL for up to 30 s server-side; the client waits longer (TMMAPI-0087). */
const GHL_SAVE_TIMEOUT_MS = 35_000;

function compactParams(q?: object): Record<string, string | number> | undefined {
  if (!q) return undefined;
  const params: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(q)) {
    if (typeof value === 'string' || typeof value === 'number') params[key] = value;
  }
  return Object.keys(params).length > 0 ? params : undefined;
}

/** Per-call options a caller may pass to a read (TMMPDM-0040). */
export interface RequestOptions {
  /** Aborts the request — a superseded search. */
  signal?: AbortSignal;
}

function signalOf(opts?: RequestOptions): { signal?: AbortSignal } {
  return opts?.signal ? { signal: opts.signal } : {};
}

function tenantPath(slug: string, suffix = ''): string {
  return `/v1/admin/tenants/${encodeURIComponent(slug)}${suffix}`;
}

function resellerPath(id: number, suffix = ''): string {
  return `/v1/admin/resellers/${encodeURIComponent(String(id))}${suffix}`;
}

function customerRateCardPath(id: number, suffix = ''): string {
  return `/v1/admin/customer-rate-cards/${encodeURIComponent(String(id))}${suffix}`;
}

function commissionPlanPath(resellerId: number, id: number, suffix = ''): string {
  return resellerPath(resellerId, `/commission-plans/${encodeURIComponent(String(id))}${suffix}`);
}

function affiliatePath(slug: string, id: number, suffix = ''): string {
  return tenantPath(slug, `/affiliates/${encodeURIComponent(String(id))}${suffix}`);
}

/** A partner's ledger (TMMAPI-0162 item 22): the payee ref is the addressed resource, never authority. */
function ledgerPath(payeeRef: string, suffix = ''): string {
  return `/v1/admin/partners/${encodeURIComponent(payeeRef)}/ledger${suffix}`;
}

const CUTOVER_PATH = '/v1/admin/billing/ledger';

const ANNOUNCEMENTS_PATH = '/v1/admin/announcements';

/** An announcement (TMMAPI-0181 item 32a): its id is the addressed resource, never authority. */
function announcementPath(id: number, suffix = ''): string {
  return `${ANNOUNCEMENTS_PATH}/${encodeURIComponent(String(id))}${suffix}`;
}

/** A ticket (TMMAPI-0181 U5): its number is the addressed resource, never authority. */
function ticketPath(number: number, suffix = ''): string {
  return `/v1/admin/tickets/${encodeURIComponent(String(number))}${suffix}`;
}

/** A merchant pattern (TMMAPI-0194 item 7): its id is the addressed resource, never authority. */
function merchantPatternPath(id: number, suffix = ''): string {
  return `/v1/admin/merchant-patterns/${encodeURIComponent(String(id))}${suffix}`;
}

/** An institution request (TMMAPI-0195 item 3): its id is the addressed resource, never authority. */
function institutionRequestPath(id: number, suffix = ''): string {
  return `/v1/admin/institution-requests/${encodeURIComponent(String(id))}${suffix}`;
}

export const adminApi = {
  /** `GET /v1/admin/dashboard` — fleet figures for the period; server-computed. */
  async dashboard(query: DashboardQuery): Promise<FleetDashboard> {
    const { data } = await api.get<FleetDashboard>('/v1/admin/dashboard', {
      params: compactParams(query),
    });
    return data;
  },

  /**
   * `GET /v1/admin/tenants?q&status&resellerId&page&size` — one server page of flat, complete
   * `TenantView`s (read `tenants`). Callers joining "all tenants" by slug pass `{ size: 200 }`.
   * TMMPDM-0040: an optional `signal` lets a newer palette search cancel an older one.
   */
  async listTenants(q?: TenantListQuery, opts?: RequestOptions): Promise<TenantList> {
    const { data } = await api.get<TenantList>('/v1/admin/tenants', {
      params: compactParams(q),
      ...signalOf(opts),
    });
    return data;
  },

  /** `GET /v1/admin/tenants/{slug}` — 404 `TENANT_NOT_FOUND` for a slug that is gone. */
  async getTenant(slug: string): Promise<TenantView> {
    const { data } = await api.get<TenantView>(tenantPath(slug));
    return data;
  },

  /**
   * `POST /v1/admin/tenants` — one-call create (name + resellerId required). Identical-body retry
   * is always safe after a timeout, 502 `SAAS_AUTH_OUTCOME_UNKNOWN` or 500 `TENANT_SETUP_INCOMPLETE`.
   * Client timeout 25 s.
   */
  async createTenant(body: TenantCreateRequest): Promise<TenantView> {
    const { data } = await api.post<TenantView>('/v1/admin/tenants', body, {
      timeout: TENANT_CREATE_TIMEOUT_MS,
    });
    return data;
  },

  /**
   * `GET /v1/admin/resellers` — read `content`; TMMAPI-0119 pages a standing-filtered
   * local mirror before returning its total. TMMPDM-0040: an
   * optional `signal` lets a newer palette search cancel an older one.
   */
  async listResellers(q?: ResellerListQuery, opts?: RequestOptions): Promise<ResellerPage> {
    const { data } = await api.get<ResellerPage>('/v1/admin/resellers', {
      params: compactParams(q),
      ...signalOf(opts),
    });
    return data;
  },

  /** `POST /v1/admin/resellers` — 409 `RESELLER_SLUG_TAKEN`, 400 `VALIDATION_FAILED`. */
  async createReseller(body: CreateResellerRequest): Promise<ResellerDto> {
    const { data } = await api.post<ResellerDto>('/v1/admin/resellers', body);
    return data;
  },

  /** `GET /v1/admin/resellers/{id}` — 404 outside the product. */
  async getReseller(resellerId: number): Promise<ResellerDto> {
    const { data } = await api.get<ResellerDto>(resellerPath(resellerId));
    return data;
  },

  /** `PATCH /v1/admin/resellers/{id}` — rename and/or suspend/reactivate; omitted fields unchanged. */
  async updateReseller(resellerId: number, body: UpdateResellerRequest): Promise<ResellerDto> {
    const { data } = await api.patch<ResellerDto>(resellerPath(resellerId), body);
    return data;
  },

  /**
   * `DELETE /v1/admin/resellers/{id}` — 409 `RESELLER_HAS_TENANTS` / `RESELLER_BRAND_IN_USE`, and
   */
  async deleteReseller(resellerId: number): Promise<void> {
    await api.delete(resellerPath(resellerId));
  },

  /** `GET /v1/admin/resellers/{id}/agreement` — `current` is null when none; history newest first. */
  async getResellerAgreement(resellerId: number): Promise<ResellerAgreementList> {
    const { data } = await api.get<ResellerAgreementList>(resellerPath(resellerId, '/agreement'));
    return data;
  },

  /**
   * `POST /v1/admin/resellers/{id}/agreement` — starts a new version (ends the current one and
   * re-prices every tenant). Required: `payoutCadence`; `currency` on the first agreement (TMMAPI-0154).
   */
  async startResellerAgreement(
    resellerId: number,
    body: ResellerAgreementWriteRequest,
  ): Promise<ResellerAgreementView> {
    const { data } = await api.post<ResellerAgreementView>(
      resellerPath(resellerId, '/agreement'),
      body,
    );
    return data;
  },

  /**
   * `PATCH /v1/admin/resellers/{id}/agreement/current` (TMMAPI-0114) — notes on the version in
   * force. Does not insert a version row. Body is `notes` and `version` only.
   */
  async patchResellerAgreementNotes(
    resellerId: number,
    body: ResellerAgreementNotesRequest,
  ): Promise<ResellerAgreementView> {
    const { data } = await api.patch<ResellerAgreementView>(
      resellerPath(resellerId, '/agreement/current'),
      body,
    );
    return data;
  },

  /**
   * `GET /v1/admin/resellers/{id}/standing` — minimum-commitment standing (MM-D-99). Months newest
   * first; never evaluated reads `GOOD` with empty months.
   */
  async getResellerStanding(resellerId: number): Promise<ResellerStandingView> {
    const { data } = await api.get<ResellerStandingView>(resellerPath(resellerId, '/standing'));
    return data;
  },

  /**
   * `POST /v1/admin/resellers/{id}/standing/clear` — `PROBATION` or `DEACTIVATION_DUE` → `GOOD`
   * (TMMAPI-0100); answers the standing. Any other state is 409 `RESELLER_STANDING_CONFLICT`. Its
   * shortfall charges stay open, and the reseller is emailed that it recovered. TMMAPI-0102: a
   * reseller saas-auth holds suspended is 409 `RESELLER_SUSPENDED_USE_REACTIVATE`; nothing changes.
   */
  async clearStanding(resellerId: number, reason: string): Promise<ResellerStandingView> {
    const body: ResellerStandingClearRequest = { reason };
    const { data } = await api.post<ResellerStandingView>(
      resellerPath(resellerId, '/standing/clear'),
      body,
    );
    return data;
  },

  /**
   * `POST /v1/admin/resellers/{id}/reactivate` — `DEACTIVATED` → `GOOD`; answers the standing
   * (`reactivatedAt` set). TMMAPI-0119: also a `DEACTIVATION_DUE` take-over that saas-auth
   * holds `SUSPENDED`, exactly when `reactivateOffered`; its deactivation window is closed.
   * An ordinary suspension is 409 `RESELLER_NOT_DEACTIVATED` (use the status toggle), and
   * other conflicts remain 409 `RESELLER_STANDING_CONFLICT`. Tenants are not moved back and its shortfall
   * charges stay open. 502 `SAAS_AUTH_OUTCOME_UNKNOWN` → re-read, never auto re-POST.
   */
  async reactivateReseller(resellerId: number, reason: string): Promise<ResellerStandingView> {
    const body: ResellerReactivateRequest = { reason };
    const { data } = await api.post<ResellerStandingView>(
      resellerPath(resellerId, '/reactivate'),
      body,
    );
    return data;
  },

  /**
   * `GET /v1/admin/resellers/{id}/billing/card` — the card on file, read-only; the JSON `null`
   * body (200) when the reseller has none. Its `clientAction` is never read (TMMPDM-0037).
   */
  async getResellerBillingCard(resellerId: number): Promise<ResellerBillingCard | null> {
    const { data } = await api.get<ResellerBillingCard | null>(
      resellerPath(resellerId, '/billing/card'),
    );
    return data ?? null;
  },

  /** `GET /v1/admin/resellers/{id}/billing/charges` — newest first. */
  async listResellerCharges(resellerId: number): Promise<ResellerChargeList> {
    const { data } = await api.get<ResellerChargeList>(
      resellerPath(resellerId, '/billing/charges'),
    );
    return data;
  },

  /**
   * `POST …/billing/charges/{chargeId}/retry` (no body) — retries a `retryable` charge (TMMAPI-0109:
   * `FAILED`, or `REQUIRES_ACTION` + `REVERIFY_CARD`) as a new attempt and answers the charge. 409
   * `RESELLER_CHARGE_NOT_RETRYABLE` (any other charge), 404
   * `RESELLER_CHARGE_NOT_FOUND`, 409 `MERCHANT_OF_RECORD_UNSET`, 409 `CONCURRENT_UPDATE` (retryable).
   */
  async retryResellerCharge(resellerId: number, chargeId: number): Promise<ResellerCharge> {
    const { data } = await api.post<ResellerCharge>(
      resellerPath(resellerId, `/billing/charges/${encodeURIComponent(String(chargeId))}/retry`),
    );
    return data;
  },

  /**
   * `GET /v1/admin/resellers/{id}/notices` — every standing email about the reseller, newest first
   * (TMMAPI-0100). Recipients are counted, never listed.
   */
  async listResellerNotices(resellerId: number): Promise<ResellerNoticeList> {
    const { data } = await api.get<ResellerNoticeList>(resellerPath(resellerId, '/notices'));
    return data;
  },

  /**
   * `GET /v1/admin/resellers/{id}/settlements?from&to&currency` — one per month per currency,
   * newest first, each with its lines and `byLine`. Blank filters are not sent.
   */
  async listResellerSettlements(
    resellerId: number,
    q: SettlementQuery = {},
  ): Promise<PayoutStatementList> {
    const { data } = await api.get<PayoutStatementList>(resellerPath(resellerId, '/settlements'), {
      params: compactParams({
        ...(q.from ? { from: q.from } : {}),
        ...(q.to ? { to: q.to } : {}),
        ...(q.currency ? { currency: q.currency } : {}),
      }),
    });
    return data;
  },

  /**
   * `POST /v1/admin/resellers/{id}/brand` (no body) — 201 with the reseller (`defaultBrandId` set),
   * or 200 with it when the brand already exists: both are success. 409
   * `PRODUCT_HAS_NO_DEFAULT_BRAND` / `BRAND_SLUG_GENERATION_FAILED` pass through; 502
   * `SAAS_AUTH_OUTCOME_UNKNOWN` → re-read the reseller, never re-POST. Client timeout 25 s.
   */
  async createResellerBrand(resellerId: number): Promise<ResellerDto> {
    const { data } = await api.post<ResellerDto>(resellerPath(resellerId, '/brand'), undefined, {
      timeout: RESELLER_BRAND_TIMEOUT_MS,
    });
    return data;
  },

  /** TMMAPI-0116: no-body takeover; unknown suspension outcome must re-read. */
  async deactivateReseller(resellerId: number): Promise<ResellerStandingView> {
    const { data } = await api.post<ResellerStandingView>(resellerPath(resellerId, '/deactivate'));
    return data;
  },

  /** `GET /v1/admin/resellers/{id}/ghl-integration` — the masked read; `null` when there is none (404). */
  async getResellerGhl(resellerId: number): Promise<ResellerGhlIntegrationDto | null> {
    try {
      const { data } = await api.get<ResellerGhlIntegrationDto>(
        resellerPath(resellerId, '/ghl-integration'),
      );
      return data;
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) return null;
      throw err;
    }
  },

  /**
   * `PUT /v1/admin/resellers/{id}/ghl-integration` — create or replace. The caller sends
   * `privateIntegrationToken` only when non-blank. 409 `GHL_LOCATION_ALREADY_CLAIMED`; 422
   * `GHL_LOCATION_NOT_VERIFIED` (proof of control, up to 30 s server-side — client timeout 35 s).
   */
  async upsertResellerGhl(
    resellerId: number,
    body: UpsertResellerGhlRequest,
  ): Promise<ResellerGhlIntegrationDto> {
    const { data } = await api.put<ResellerGhlIntegrationDto>(
      resellerPath(resellerId, '/ghl-integration'),
      body,
      { timeout: GHL_SAVE_TIMEOUT_MS },
    );
    return data;
  },

  /** `DELETE /v1/admin/resellers/{id}/ghl-integration`. */
  async deleteResellerGhl(resellerId: number): Promise<void> {
    await api.delete(resellerPath(resellerId, '/ghl-integration'));
  },

  /**
   * `POST /v1/admin/resellers/{id}/ghl-integration/diagnose` — two live GHL probes and the
   * server's interpretation. 404 when there is no active connection. Never carries the token.
   */
  async diagnoseResellerGhl(resellerId: number): Promise<ResellerGhlIntegrationDiagnosisDto> {
    const { data } = await api.post<ResellerGhlIntegrationDiagnosisDto>(
      resellerPath(resellerId, '/ghl-integration/diagnose'),
      undefined,
      { timeout: GHL_DIAGNOSE_TIMEOUT_MS },
    );
    return data;
  },

  /** `GET /v1/admin/tenants/{slug}/whitelabel-domain` — `configured: false` when there is none. */
  async getWhitelabel(slug: string): Promise<WhitelabelDomainDto> {
    const { data } = await api.get<WhitelabelDomainDto>(tenantPath(slug, '/whitelabel-domain'));
    return data;
  },

  /**
   * `GET /v1/admin/tenants/{slug}/billing/client-config` (default `scope=tenant`, the only scope read
   * here) — the cached pay-api public keys; 503 `PAY_API_UNAVAILABLE` while the cache is empty.
   */
  async getBillingClientConfig(slug: string): Promise<ScopedBillingClientConfig> {
    const { data } = await api.get<ScopedBillingClientConfig>(
      tenantPath(slug, '/billing/client-config'),
    );
    return data;
  },

  /**
   * `POST …/billing/client-config/refresh` (TMMAPI-0129) — re-reads the tenant's keys from pay-api now;
   * audited and safe to repeat. 200 is the GET's view; 503 `PAY_API_UNAVAILABLE` when pay-api reports
   * the tenant unconfigured (the cache is cleared) or can't be reached (the cache is unchanged).
   */
  async refreshBillingClientConfig(slug: string): Promise<ScopedBillingClientConfig> {
    const { data } = await api.post<ScopedBillingClientConfig>(
      tenantPath(slug, '/billing/client-config/refresh'),
    );
    return data;
  },

  /**
   * `POST …/billing/provision` (TMMAPI-0130) — provisions the tenant's billing connection on the
   * platform's Stripe account at pay-api and stamps `billingProvisionedAt`; audited and safe to repeat.
   * 409 `BILLING_CONNECTION_CONFLICT` / 503 `PAY_API_UNAVAILABLE` carry `details.reason`.
   */
  async provisionTenantBilling(slug: string): Promise<AdminTenantBillingState> {
    const { data } = await api.post<AdminTenantBillingState>(
      tenantPath(slug, '/billing/provision'),
    );
    return data;
  },

  /** `GET …/whitelabel-domain/template` — suggested `hosts` for a PUT; nothing is written. */
  async getWhitelabelTemplate(slug: string): Promise<WhitelabelTemplateDto> {
    const { data } = await api.get<WhitelabelTemplateDto>(
      tenantPath(slug, '/whitelabel-domain/template'),
    );
    return data;
  },

  /**
   * `PUT …/whitelabel-domain` — full create-or-replace. `WHITELABEL_*` /
   * `HOSTNAME_ALREADY_REGISTERED` pass through from saas-auth.
   */
  async putWhitelabel(
    slug: string,
    body: PutWhitelabelDomainRequest,
  ): Promise<WhitelabelDomainDto> {
    const { data } = await api.put<WhitelabelDomainDto>(
      tenantPath(slug, '/whitelabel-domain'),
      body,
    );
    return data;
  },

  /** `DELETE …/whitelabel-domain` — 404 when there is none. */
  async deleteWhitelabel(slug: string): Promise<void> {
    await api.delete(tenantPath(slug, '/whitelabel-domain'));
  },

  /** `POST …/whitelabel-domain/verify` — checks every hostname's DNS; ACTIVE only when all pass. */
  async verifyWhitelabel(slug: string): Promise<WhitelabelVerifyResponse> {
    const { data } = await api.post<WhitelabelVerifyResponse>(
      tenantPath(slug, '/whitelabel-domain/verify'),
      undefined,
      { timeout: WHITELABEL_VERIFY_TIMEOUT_MS },
    );
    return data;
  },

  /** `GET /v1/admin/dashboard?from&to&tenantSlug=` — callers read `tenants[0]`. */
  async tenantDashboard(slug: string, q: { from: string; to: string }): Promise<FleetDashboard> {
    return adminApi.dashboard({ from: q.from, to: q.to, tenantSlug: slug });
  },

  /** `PATCH /v1/admin/tenants/{slug}` — send only changed fields; never `kind`. */
  async patchTenant(slug: string, body: TenantPatchRequest): Promise<TenantView> {
    const { data } = await api.patch<TenantView>(tenantPath(slug), body);
    return data;
  },

  async getProductSettings(): Promise<ProductSettingsView> {
    const { data } = await api.get<ProductSettingsView>('/v1/admin/product-settings');
    return data;
  },

  async putProductSettings(settings: Record<string, string>): Promise<ProductSettingsView> {
    const { data } = await api.put<ProductSettingsView>('/v1/admin/product-settings', {
      settings,
    });
    return data;
  },

  /**
   * `GET /v1/admin/customer-rate-cards` (TMMAPI-0131). Versions, grants and adopting reseller ids
   * travel on each card. There is no per-version GET.
   */
  async listCustomerRateCards(opts?: RequestOptions): Promise<CustomerRateCardList> {
    const { data } = await api.get<CustomerRateCardList>(
      '/v1/admin/customer-rate-cards',
      signalOf(opts),
    );
    return data;
  },

  async getCustomerRateCard(id: number): Promise<CustomerRateCardView> {
    const { data } = await api.get<CustomerRateCardView>(customerRateCardPath(id));
    return data;
  },

  /** `POST /v1/admin/customer-rate-cards` (201) — the card plus its first DRAFT version. */
  async createCustomerRateCard(body: CustomerRateCardCreateRequest): Promise<CustomerRateCardView> {
    const { data } = await api.post<CustomerRateCardView>('/v1/admin/customer-rate-cards', body);
    return data;
  },

  /** Name any time; currency only while nothing is published (409 `RATE_CARD_IMMUTABLE`). */
  async patchCustomerRateCard(
    id: number,
    body: CustomerRateCardPatchRequest,
  ): Promise<CustomerRateCardView> {
    const { data } = await api.patch<CustomerRateCardView>(customerRateCardPath(id), body);
    return data;
  },

  /**
   * `POST …/versions` (201). An omitted body copies the latest version. Callers that mean the
   * current version's terms send those terms.
   */
  async addCustomerRateCardVersion(
    id: number,
    body?: CustomerRateCardVersionWrite,
  ): Promise<CustomerRateCardVersionView> {
    const { data } = await api.post<CustomerRateCardVersionView>(
      customerRateCardPath(id, '/versions'),
      body,
    );
    return data;
  },

  /** DRAFT only (409 `RATE_CARD_IMMUTABLE`). Stale `version` is 409 `RATE_CARD_VERSION_CONFLICT`. */
  async patchCustomerRateCardVersion(
    id: number,
    versionId: number,
    body: CustomerRateCardVersionWrite,
  ): Promise<CustomerRateCardVersionView> {
    const { data } = await api.patch<CustomerRateCardVersionView>(
      customerRateCardPath(id, `/versions/${encodeURIComponent(String(versionId))}`),
      body,
    );
    return data;
  },

  /**
   * `POST …/versions/{versionId}/publish`. A failed check is 409 `RATE_CARD_INVALID` with
   * `details.fields[]` (`{field, reason}`, TMMAPI-0154) and leaves the version DRAFT. Earlier
   * PUBLISHED versions stay PUBLISHED.
   */
  async publishCustomerRateCardVersion(
    id: number,
    versionId: number,
  ): Promise<CustomerRateCardVersionView> {
    const { data } = await api.post<CustomerRateCardVersionView>(
      customerRateCardPath(id, `/versions/${encodeURIComponent(String(versionId))}/publish`),
    );
    return data;
  },

  /** A card with no published version can still be granted. */
  async grantCustomerRateCard(id: number, resellerId: number): Promise<CustomerRateCardView> {
    const { data } = await api.post<CustomerRateCardView>(customerRateCardPath(id, '/grants'), {
      resellerId,
    });
    return data;
  },

  /** The adopted card is 409 `CARD_ADOPTED`. A missing grant is 404 `RATE_CARD_NOT_FOUND`. */
  async revokeCustomerRateCard(id: number, resellerId: number): Promise<CustomerRateCardView> {
    const { data } = await api.delete<CustomerRateCardView>(
      customerRateCardPath(id, `/grants/${encodeURIComponent(String(resellerId))}`),
    );
    return data;
  },

  /** No request body. No preview. No published version is 409 `RATE_CARD_NOT_ACTIVE`. */
  async moveCustomerRateCardSubscribers(id: number): Promise<CustomerRateCardMoveResult> {
    const { data } = await api.post<CustomerRateCardMoveResult>(
      customerRateCardPath(id, '/move-subscribers'),
    );
    return data;
  },

  /**
   * `POST …/subscriptions/{subscriptionId}/move` (TMMAPI-0131, pin `6e36a38`). 200
   * `CustomerRateCardMoveResult`. A subscription that is not on this card is 404
   * `SUBSCRIPTION_NOT_FOUND` (the same code as a missing subscription). No published version is
   * 409 `RATE_CARD_NOT_ACTIVE`. The console calls this only from a surface that already has both
   * ids. There is no subscribers list on the card.
   */
  async moveCustomerRateCardSubscription(
    id: number,
    subscriptionId: number,
  ): Promise<CustomerRateCardMoveResult> {
    const { data } = await api.post<CustomerRateCardMoveResult>(
      customerRateCardPath(id, `/subscriptions/${encodeURIComponent(String(subscriptionId))}/move`),
    );
    return data;
  },

  /**
   * `POST …/versions/{versionId}/worksheet` (TMMAPI-0154): the margin worksheet, per month and
   * signed, on any version (drafts included). A pure computation; the console renders it as sent.
   */
  async customerRateCardWorksheet(
    id: number,
    versionId: number,
    body: WorksheetRequest,
    opts?: RequestOptions,
  ): Promise<AdminWorksheet> {
    const { data } = await api.post<AdminWorksheet>(
      customerRateCardPath(id, `/versions/${encodeURIComponent(String(versionId))}/worksheet`),
      body,
      signalOf(opts),
    );
    return data;
  },

  /**
   * `GET /v1/admin/billing/processing-fees/{currency}` (TMMAPI-0154). `current` is `null` before
   * the first rate (no fee is posted without one).
   */
  async getProcessingFees(currency: string): Promise<ProcessingFeeRatesView> {
    const { data } = await api.get<ProcessingFeeRatesView>(
      `/v1/admin/billing/processing-fees/${encodeURIComponent(currency)}`,
    );
    return data;
  },

  /** `PUT …/processing-fees/{currency}`: effective now when `effectiveFrom` is absent; never back-dated. */
  async setProcessingFee(
    currency: string,
    body: ProcessingFeeRateWrite,
  ): Promise<ProcessingFeeRatesView> {
    const { data } = await api.put<ProcessingFeeRatesView>(
      `/v1/admin/billing/processing-fees/${encodeURIComponent(currency)}`,
      body,
    );
    return data;
  },

  /**
   * `POST /v1/admin/resellers/{resellerId}/customer-rate-cards/{cardId}/adopt`.
   * An unpublished card is 409 `RATE_CARD_NOT_ACTIVE`. Not granted is 404 `RATE_CARD_NOT_FOUND`.
   */
  async adoptCustomerRateCard(
    resellerId: number,
    cardId: number,
  ): Promise<GrantedCustomerRateCardView> {
    const { data } = await api.post<GrantedCustomerRateCardView>(
      resellerPath(resellerId, `/customer-rate-cards/${encodeURIComponent(String(cardId))}/adopt`),
    );
    return data;
  },

  /**
   * TMMAPI-0153: a card's live controls (TMMAPI-0154 adds the four affiliate maximums, optional on
   * a write: absent keeps the one in force). `GET` and `POST` answer
   * `{cardId, current, scheduled[], history[], currency, reviewSuggested}`; `POST` takes a full row with
   * `effectiveFrom` absent for now; `DELETE` withdraws a future row softly (409
   * `SETTING_IN_EFFECT` once in effect, `ROW_IN_FORCE` within a minute of it, `LAST_ROW` for the
   * card's last row not withdrawn; 204 when already withdrawn). 409 `EFFECTIVE_FROM_TAKEN`
   * on a duplicate instant; 404 `RATE_CARD_NOT_FOUND` / `NOT_FOUND`.
   */
  async getCardControls(cardId: number): Promise<CardControlsEnvelope> {
    const { data } = await api.get<CardControlsEnvelope>(customerRateCardPath(cardId, '/controls'));
    return data;
  },

  async scheduleCardControls(cardId: number, body: SettingWrite): Promise<CardControlsEnvelope> {
    const { data } = await api.post<CardControlsEnvelope>(
      customerRateCardPath(cardId, '/controls'),
      body,
    );
    return data;
  },

  async withdrawCardControls(cardId: number, rowId: number, note?: string): Promise<void> {
    await api.delete(
      customerRateCardPath(cardId, `/controls/${encodeURIComponent(String(rowId))}`),
      note ? { params: { note } } : undefined,
    );
  },

  /** TMMAPI-0153: the platform's domain-helper AI caps; the same shapes and errors. */
  async getPlatformAiControls(): Promise<PlatformAiControlsEnvelope> {
    const { data } = await api.get<PlatformAiControlsEnvelope>('/v1/admin/ai-controls');
    return data;
  },

  async schedulePlatformAiControls(body: SettingWrite): Promise<PlatformAiControlsEnvelope> {
    const { data } = await api.post<PlatformAiControlsEnvelope>('/v1/admin/ai-controls', body);
    return data;
  },

  async withdrawPlatformAiControls(rowId: number, note?: string): Promise<void> {
    await api.delete(
      `/v1/admin/ai-controls/${encodeURIComponent(String(rowId))}`,
      note ? { params: { note } } : undefined,
    );
  },

  /** `GET /v1/admin/resellers/{resellerId}/commission-plans` — the reseller's own plans. */
  async listCommissionPlans(resellerId: number): Promise<CommissionPlanList> {
    const { data } = await api.get<CommissionPlanList>(
      resellerPath(resellerId, '/commission-plans'),
    );
    return data;
  },

  /**
   * `POST …/commission-plans` (201) — a new DRAFT. Nothing is sent: an empty body is the default
   * draft (SIMPLE, 10% for 12 months, BASE, cool-off 30, STOP). 409 `AGREEMENT_REQUIRED`; 409
   * `COMMISSION_PLAN_NAME_TAKEN` (`details.name`) when another of the reseller's plans has the name.
   */
  async createCommissionPlan(resellerId: number): Promise<CommissionPlanView> {
    const { data } = await api.post<CommissionPlanView>(
      resellerPath(resellerId, '/commission-plans'),
    );
    return data;
  },

  /**
   * `POST …/commission-plans/preview` — the dry run priced on the reseller's own `rateCardId`;
   * writes nothing. 404 `RATE_CARD_NOT_FOUND` for a card not the reseller's.
   */
  async previewCommissionPlan(
    resellerId: number,
    body: CommissionPlanPreviewRequest,
  ): Promise<CommissionPlanPreview> {
    const { data } = await api.post<CommissionPlanPreview>(
      resellerPath(resellerId, '/commission-plans/preview'),
      body,
    );
    return data;
  },

  /** `GET …/commission-plans/{id}` — 404 `COMMISSION_PLAN_NOT_FOUND` for another reseller's. */
  async getCommissionPlan(resellerId: number, id: number): Promise<CommissionPlanView> {
    const { data } = await api.get<CommissionPlanView>(commissionPlanPath(resellerId, id));
    return data;
  },

  /**
   * `PATCH …/commission-plans/{id}` — name in any state; mode and other terms DRAFT only
   * (409 `COMMISSION_PLAN_IMMUTABLE`). A name another of the reseller's plans has is 409
   * `COMMISSION_PLAN_NAME_TAKEN` (`details.name`).
   */
  async patchCommissionPlan(
    resellerId: number,
    id: number,
    body: CommissionPlanWriteRequest,
  ): Promise<CommissionPlanView> {
    const { data } = await api.patch<CommissionPlanView>(commissionPlanPath(resellerId, id), body);
    return data;
  },

  /**
   * `POST …/{id}/activate` — DRAFT → ACTIVE, checked against the adopted card's affiliate
   * maximums (TMMAPI-0154; 409 `NO_RATE_CARD` without an adoption); an ACTIVE plan answers as it is; a CLOSED one is 409 `COMMISSION_PLAN_IMMUTABLE`.
   */
  async activateCommissionPlan(resellerId: number, id: number): Promise<CommissionPlanView> {
    const { data } = await api.post<CommissionPlanView>(
      commissionPlanPath(resellerId, id, '/activate'),
    );
    return data;
  },

  /** `POST …/{id}/close` — idempotent; affiliates already on it keep it. */
  async closeCommissionPlan(resellerId: number, id: number): Promise<CommissionPlanView> {
    const { data } = await api.post<CommissionPlanView>(
      commissionPlanPath(resellerId, id, '/close'),
    );
    return data;
  },

  /**
   * `POST …/{id}/copy` (201) — a new DRAFT with the plan's terms; the way to change or fix one.
   * 409 `COMMISSION_PLAN_NAME_TAKEN` (`details.name`) from the shared service when the copy's name
   * is taken.
   */
  async copyCommissionPlan(resellerId: number, id: number): Promise<CommissionPlanView> {
    const { data } = await api.post<CommissionPlanView>(
      commissionPlanPath(resellerId, id, '/copy'),
    );
    return data;
  },

  async listOffers(slug: string): Promise<OfferList> {
    const { data } = await api.get<OfferList>(tenantPath(slug, '/offers'));
    return data;
  },

  async listPromotions(slug: string): Promise<PromotionList> {
    const { data } = await api.get<PromotionList>(tenantPath(slug, '/promotions'));
    return data;
  },

  async listSubscriptions(slug: string, q?: SubscriptionListQuery): Promise<AdminSubscriptionList> {
    const { data } = await api.get<AdminSubscriptionList>(tenantPath(slug, '/subscriptions'), {
      params: compactParams(q),
    });
    return data;
  },

  async subscribe(slug: string, body: AdminSubscribeRequest): Promise<AdminSubscribeResponse> {
    const { data } = await api.post<AdminSubscribeResponse>(
      tenantPath(slug, '/subscriptions'),
      body,
    );
    return data;
  },

  async getSubscription(slug: string, id: number): Promise<AdminSubscriptionDetail> {
    const { data } = await api.get<AdminSubscriptionDetail>(
      tenantPath(slug, `/subscriptions/${encodeURIComponent(String(id))}`),
    );
    return data;
  },

  async cancelSubscription(
    slug: string,
    id: number,
    body: AdminCancelRequest,
  ): Promise<CancelResponse> {
    const { data } = await api.post<CancelResponse>(
      tenantPath(slug, `/subscriptions/${encodeURIComponent(String(id))}/cancel`),
      body,
    );
    return data;
  },

  async changeOffer(
    slug: string,
    id: number,
    body: AdminChangeOfferRequest,
  ): Promise<AdminSubscriptionRow> {
    const { data } = await api.post<AdminSubscriptionRow>(
      tenantPath(slug, `/subscriptions/${encodeURIComponent(String(id))}/change-offer`),
      body,
    );
    return data;
  },

  async compSubscription(
    slug: string,
    id: number,
    body: AdminCompRequest,
  ): Promise<AdminSubscriptionRow> {
    const { data } = await api.post<AdminSubscriptionRow>(
      tenantPath(slug, `/subscriptions/${encodeURIComponent(String(id))}/comp`),
      body,
    );
    return data;
  },

  async applyPromotion(
    slug: string,
    id: number,
    body: ApplyPromotionRequest,
  ): Promise<AdminSubscriptionRow> {
    const { data } = await api.post<AdminSubscriptionRow>(
      tenantPath(slug, `/subscriptions/${encodeURIComponent(String(id))}/apply-promotion`),
      body,
    );
    return data;
  },

  /**
   * Ends the promotion applied to the subscription, not the code (tmm-api 0124). 200 is the row with
   * `appliedPromotion: null`; 409 `PROMOTION_NOT_APPLIED` when none is applied.
   */
  async endPromotion(slug: string, id: number): Promise<AdminSubscriptionRow> {
    const { data } = await api.post<AdminSubscriptionRow>(
      tenantPath(slug, `/subscriptions/${encodeURIComponent(String(id))}/end-promotion`),
    );
    return data;
  },

  async setAiSuspension(
    slug: string,
    id: number,
    body: AiSuspensionRequest,
  ): Promise<AiSuspensionResponse> {
    const { data } = await api.post<AiSuspensionResponse>(
      tenantPath(slug, `/subscriptions/${encodeURIComponent(String(id))}/ai-suspension`),
      body,
    );
    return data;
  },

  async listStatements(slug: string, q?: StatementListQuery): Promise<AdminStatementList> {
    const { data } = await api.get<AdminStatementList>(tenantPath(slug, '/statements'), {
      params: compactParams(q),
    });
    return data;
  },

  async retryStatement(slug: string, id: number): Promise<StatementView> {
    const { data } = await api.post<StatementView>(
      tenantPath(slug, `/statements/${encodeURIComponent(String(id))}/retry`),
    );
    return data;
  },

  async waiveStatement(slug: string, id: number, body: AdminWaiveRequest): Promise<StatementView> {
    const { data } = await api.post<StatementView>(
      tenantPath(slug, `/statements/${encodeURIComponent(String(id))}/waive`),
      body,
    );
    return data;
  },

  async listSeats(slug: string, q?: SeatListQuery): Promise<AdminSeatList> {
    const { data } = await api.get<AdminSeatList>(tenantPath(slug, '/seats'), {
      params: compactParams(q),
    });
    return data;
  },

  async revenue(q: RevenueQuery): Promise<RevenueReport> {
    const { data } = await api.get<RevenueReport>('/v1/admin/revenue', {
      params: compactParams(q),
    });
    return data;
  },

  async tenantRevenue(slug: string, q: RevenueQuery): Promise<RevenueReport> {
    const { data } = await api.get<RevenueReport>(tenantPath(slug, '/revenue'), {
      params: compactParams(q),
    });
    return data;
  },

  async payoutRunSheet(status?: PayoutStatus, resellerId?: number): Promise<RunSheet> {
    const { data } = await api.get<RunSheet>('/v1/admin/payouts', {
      params: compactParams({
        ...(status ? { status } : {}),
        ...(resellerId !== undefined ? { resellerId } : {}),
      }),
    });
    return data;
  },

  async payoutRunSheetCsv(status?: PayoutStatus, resellerId?: number): Promise<Blob> {
    const { data } = await api.get<Blob>('/v1/admin/payouts.csv', {
      params: compactParams({
        ...(status ? { status } : {}),
        ...(resellerId !== undefined ? { resellerId } : {}),
      }),
      responseType: 'blob',
      headers: { Accept: 'text/csv' },
    });
    return data;
  },

  async listPayoutStatements(slug: string): Promise<PayoutStatementList> {
    const { data } = await api.get<PayoutStatementList>(tenantPath(slug, '/payout-statements'));
    return data;
  },

  async recordPayout(slug: string, id: number, body: PayoutRequest): Promise<PayoutStatementView> {
    const { data } = await api.post<PayoutStatementView>(
      tenantPath(slug, `/payout-statements/${encodeURIComponent(String(id))}/payout`),
      body,
    );
    return data;
  },

  async listAiModelPrices(): Promise<AiModelPriceListResponse> {
    const { data } = await api.get<AiModelPriceListResponse>('/v1/admin/billing/ai-model-prices');
    return data;
  },

  async createAiModelPrice(body: AiModelPriceCreateRequest): Promise<AiModelPriceRow> {
    const { data } = await api.post<AiModelPriceRow>('/v1/admin/billing/ai-model-prices', body);
    return data;
  },

  /**
   * `DELETE /v1/admin/billing/ai-model-prices/{id}?note=` (TMMAPI-0165). 204 or 200 withdraws; 409
   * `PRICE_IN_USE` or `SETTING_IN_EFFECT`; 404 `NOT_FOUND`. The caller re-reads.
   */
  async withdrawAiModelPrice(id: number, note?: string): Promise<void> {
    await api.delete(
      `/v1/admin/billing/ai-model-prices/${encodeURIComponent(String(id))}`,
      note ? { params: { note } } : undefined,
    );
  },

  /** `GET /v1/admin/ai-models` (TMMAPI-0171): the catalogue, active models first. */
  async listAiModels(): Promise<AiModelCatalogList> {
    const { data } = await api.get<AiModelCatalogList>('/v1/admin/ai-models');
    return data;
  },

  /**
   * `POST /v1/admin/ai-models`. Verified with Anthropic before saving: 409
   * `AI_MODEL_NOT_AT_PROVIDER`, 503 `AI_PROVIDER_UNAVAILABLE` (`details.reason`), 409
   * `AI_MODEL_EXISTS`; 400 `fields.modelId` / `fields.fast`. A retired id is reactivated (200).
   */
  async addAiModel(body: AiModelCatalogAddRequest): Promise<AiModelCatalogRow> {
    const { data } = await api.post<AiModelCatalogRow>('/v1/admin/ai-models', body);
    return data;
  },

  /** `PATCH /v1/admin/ai-models/{id}`: only the keys sent change. 409 `AI_MODEL_IN_USE` (`details.tiers`). */
  async patchAiModel(id: number, body: AiModelCatalogPatchRequest): Promise<AiModelCatalogRow> {
    const { data } = await api.patch<AiModelCatalogRow>(
      `/v1/admin/ai-models/${encodeURIComponent(String(id))}`,
      body,
    );
    return data;
  },

  /** `POST /v1/admin/ai-models/{id}/verify`: looks the model up with Anthropic again. */
  async verifyAiModel(id: number): Promise<AiModelCatalogRow> {
    const { data } = await api.post<AiModelCatalogRow>(
      `/v1/admin/ai-models/${encodeURIComponent(String(id))}/verify`,
    );
    return data;
  },

  /**
   * `DELETE /v1/admin/ai-models/{id}?note=` (retire; soft). 204, also on a repeat; 409
   * `AI_MODEL_IN_USE`; 404 `NOT_FOUND`. The caller re-reads.
   */
  async retireAiModel(id: number, note?: string): Promise<void> {
    await api.delete(
      `/v1/admin/ai-models/${encodeURIComponent(String(id))}`,
      note ? { params: { note } } : undefined,
    );
  },

  /** `GET /v1/admin/ai-model-assignments` (TMMAPI-0165 section A). */
  async getModelAssignments(): Promise<AiModelAssignmentsView> {
    const { data } = await api.get<AiModelAssignmentsView>('/v1/admin/ai-model-assignments');
    return data;
  },

  /** `POST /v1/admin/ai-model-assignments`. `effectiveFrom` absent means now. The caller re-reads. */
  async scheduleModelAssignment(body: AiModelAssignmentWrite): Promise<void> {
    await api.post('/v1/admin/ai-model-assignments', body);
  },

  /** `DELETE /v1/admin/ai-model-assignments/{id}?note=`. The caller re-reads. */
  async withdrawModelAssignment(id: number, note?: string): Promise<void> {
    await api.delete(
      `/v1/admin/ai-model-assignments/${encodeURIComponent(String(id))}`,
      note ? { params: { note } } : undefined,
    );
  },

  async billingAttention(): Promise<BillingAttention> {
    const { data } = await api.get<BillingAttention>('/v1/admin/billing/attention');
    return data;
  },

  /**
   * `POST /v1/admin/billing/skus/declare` (0159, audited, idempotent): re-declares tmm's products to
   * pay-api. No body. 503 `PAY_API_UNAVAILABLE` when pay-api isn't configured.
   */
  async declareSkus(): Promise<SkuDeclarations> {
    const { data } = await api.post<SkuDeclarations>('/v1/admin/billing/skus/declare');
    return data;
  },

  /**
   * `POST /v1/admin/billing/payees/backfill` (0161, audited `PAYEES_BACKFILLED`, idempotent): registers
   * the existing partners as pay-api payees. No body; run once, after pay-api's payee adoption. 503
   * `PAY_API_UNAVAILABLE` when pay-api or its payout key isn't configured.
   */
  async backfillPayees(): Promise<PayeeBackfillResult> {
    const { data } = await api.post<PayeeBackfillResult>('/v1/admin/billing/payees/backfill');
    return data;
  },

  /**
   * `GET /v1/admin/billing/parked-events` (TMMAPI-0121) — the pay-api feed events tmm-api parked,
   * newest first; `resolved` picks the unresolved list or the re-applied / dismissed one. The
   * boolean travels as `true` / `false`, which `compactParams` would drop.
   */
  async listParkedEvents(
    q: ParkedEventsQuery,
    opts?: RequestOptions,
  ): Promise<ParkedFeedEventPage> {
    const { data } = await api.get<ParkedFeedEventPage>('/v1/admin/billing/parked-events', {
      params: { resolved: String(q.resolved), page: q.page, size: q.size },
      ...signalOf(opts),
    });
    return data;
  },

  /**
   * `POST …/parked-events/{seq}/reapply {note}` — tmm-api fetches the event from pay-api and applies
   * it once. 409 `PARKED_EVENT_STILL_REFUSED` (`details.reasonCode`) and 409 `PARKED_EVENT_UNAVAILABLE`
   * change nothing; 503 `PARKED_EVENT_BUSY` (the event is locked; retry) changes nothing either;
   * 409 `PARKED_EVENT_RESOLVED`, 404 `PARKED_EVENT_NOT_FOUND`, 400 `VALIDATION_FAILED`
   * (a note of 3–500 characters).
   */
  async reapplyParkedEvent(
    seq: number,
    body: ParkedEventNoteRequest,
  ): Promise<ParkedFeedEventView> {
    const { data } = await api.post<ParkedFeedEventView>(
      `/v1/admin/billing/parked-events/${encodeURIComponent(String(seq))}/reapply`,
      body,
    );
    return data;
  },

  /** `POST …/parked-events/{seq}/dismiss {note}` — nothing is applied; the same 409 / 404 / 400 as re-apply. */
  async dismissParkedEvent(
    seq: number,
    body: ParkedEventNoteRequest,
  ): Promise<ParkedFeedEventView> {
    const { data } = await api.post<ParkedFeedEventView>(
      `/v1/admin/billing/parked-events/${encodeURIComponent(String(seq))}/dismiss`,
      body,
    );
    return data;
  },

  async listDeletionRequests(slug: string): Promise<AdminDeletionList> {
    const { data } = await api.get<AdminDeletionList>(tenantPath(slug, '/deletion-requests'));
    return data;
  },

  async requestDeletion(slug: string, body: AdminDeletionRequest): Promise<DeletionRequestView> {
    const { data } = await api.post<DeletionRequestView>(
      tenantPath(slug, '/deletion-requests'),
      body,
    );
    return data;
  },

  async cancelDeletion(slug: string, id: number, reason?: string): Promise<DeletionRequestView> {
    const path = tenantPath(slug, `/deletion-requests/${encodeURIComponent(String(id))}/cancel`);
    const trimmed = reason?.trim();
    const { data } = trimmed
      ? await api.post<DeletionRequestView>(path, { reason: trimmed })
      : await api.post<DeletionRequestView>(path);
    return data;
  },

  /**
   * 0157, 0158: erase a pending request now, or retry a `FAILED` one. 200 erased; 202 not finished
   * (`retrying: true`: the job finishes it; `retrying: false`: it has just gone `FAILED`).
   */
  async eraseDeletionNow(slug: string, id: number): Promise<ImmediateErasureView> {
    const { data } = await api.post<ImmediateErasureView>(
      tenantPath(slug, `/deletion-requests/${encodeURIComponent(String(id))}/erase-now`),
    );
    return data;
  },

  async aiUsage(slug: string, q: AiUsageQuery): Promise<UsageReport> {
    const { data } = await api.get<UsageReport>(tenantPath(slug, '/ai-usage'), {
      params: compactParams(q),
    });
    return data;
  },

  /**
   * `POST …/people/{userId}/ai-credit` (TMMAPI-0152). Idempotent on `idempotencyKey`: a replay
   * answers the first credit; the same key with another amount is 409 `IDEMPOTENCY_CONFLICT`. No
   * live subscription is 403 `SUBSCRIPTION_REQUIRED`; a person outside the tenant 404
   * `PERSON_NOT_FOUND`.
   */
  async addAiCredit(
    slug: string,
    userId: number,
    body: AdminAiCreditRequest,
  ): Promise<AdminAiCreditResponse> {
    const { data } = await api.post<AdminAiCreditResponse>(
      tenantPath(slug, `/people/${encodeURIComponent(String(userId))}/ai-credit`),
      body,
    );
    return data;
  },

  /**
   * `GET /v1/admin/ai-cost-reconciliation?from&to` (TMMAPI-0152): UTC dates, at most 366 days
   * (else 400 `VALIDATION_FAILED`). One row per UTC day per currency (0153 item 31).
   */
  async aiCostReconciliation(
    q: AiCostReconciliationQuery,
    opts?: RequestOptions,
  ): Promise<AiCostReconciliationList> {
    const { data } = await api.get<AiCostReconciliationList>('/v1/admin/ai-cost-reconciliation', {
      params: compactParams(q),
      ...signalOf(opts),
    });
    return data;
  },

  async inviteCustomer(
    slug: string,
    body: AdminInvitationRequest,
  ): Promise<AdminInvitationResponse> {
    const { data } = await api.post<AdminInvitationResponse>(
      tenantPath(slug, '/invitations'),
      body,
    );
    return data;
  },

  /** `GET /v1/admin/addon-catalog` — every catalogue item, any status. */
  async listAddonCatalog(): Promise<CatalogList> {
    const { data } = await api.get<CatalogList>('/v1/admin/addon-catalog');
    return data;
  },

  /** `POST /v1/admin/addon-catalog` — a new `DRAFT` item. 409 `ADDON_KIND_TAKEN`. */
  async createAddonCatalog(body: CatalogWriteRequest): Promise<CatalogView> {
    const { data } = await api.post<CatalogView>('/v1/admin/addon-catalog', body);
    return data;
  },

  /** `PATCH /v1/admin/addon-catalog/{kind}` — edits and the DRAFT → ACTIVE → RETIRED lifecycle. */
  async patchAddonCatalog(kind: string, body: CatalogPatchRequest): Promise<CatalogView> {
    const { data } = await api.patch<CatalogView>(
      `/v1/admin/addon-catalog/${encodeURIComponent(kind)}`,
      body,
    );
    return data;
  },

  /** `GET /v1/admin/addons?status=` — every tenant's add-ons; no status means all. */
  async listFleetAddons(status?: TenantAddonStatus): Promise<TenantAddonList> {
    const { data } = await api.get<TenantAddonList>('/v1/admin/addons', {
      params: compactParams(status ? { status } : undefined),
    });
    return data;
  },

  /** `GET /v1/admin/tenants/{slug}/addons` — the tenant's add-ons with their period charges. */
  async listTenantAddons(slug: string): Promise<TenantAddonList> {
    const { data } = await api.get<TenantAddonList>(tenantPath(slug, '/addons'));
    return data;
  },

  /** `POST /v1/admin/tenants/{slug}/addons` — an `OFFERED` row. 409 `ADDON_ACTIVE` et al. */
  async offerAddon(slug: string, body: OfferRequest): Promise<TenantAddonView> {
    const { data } = await api.post<TenantAddonView>(tenantPath(slug, '/addons'), body);
    return data;
  },

  /** `POST …/addons/{id}/withdraw` — an unaccepted offer only. */
  async withdrawAddon(slug: string, id: number): Promise<TenantAddonView> {
    const { data } = await api.post<TenantAddonView>(
      tenantPath(slug, `/addons/${encodeURIComponent(String(id))}/withdraw`),
    );
    return data;
  },

  /** `POST …/addons/{id}/cancel` — at term end, or immediately. */
  async cancelAddon(slug: string, id: number, body: AddonCancelRequest): Promise<TenantAddonView> {
    const { data } = await api.post<TenantAddonView>(
      tenantPath(slug, `/addons/${encodeURIComponent(String(id))}/cancel`),
      body,
    );
    return data;
  },

  /**
   * `GET /v1/admin/tenants/{slug}/affiliates?status=` — `status` is sent only when set.
   * The deprecated all-currency commission integer on each row is not read.
   */
  async listAffiliates(slug: string, query?: AffiliateListQuery): Promise<AffiliateList> {
    const { data } = await api.get<AffiliateList>(tenantPath(slug, '/affiliates'), {
      params: compactParams(query),
    });
    return data;
  },

  /** `GET …/affiliates/{id}` — 404 `AFFILIATE_NOT_FOUND` for another tenant's affiliate. */
  async getAffiliate(slug: string, id: number): Promise<AffiliateDetail> {
    const { data } = await api.get<AffiliateDetail>(affiliatePath(slug, id));
    return data;
  },

  /**
   * `GET …/affiliates/{id}/earnings` (TMMAPI-0105) — by month earned, newest first, in the tenant's
   * currency. Read-only. 404 `AFFILIATE_NOT_FOUND` for another tenant's affiliate.
   */
  async getAffiliateEarnings(slug: string, id: number): Promise<AffiliateEarnings> {
    const { data } = await api.get<AffiliateEarnings>(affiliatePath(slug, id, '/earnings'));
    return data;
  },

  /** `GET …/affiliates/{id}/agreement` — `{inForce, history}`. */
  async getAffiliateAgreement(slug: string, id: number): Promise<AffiliateAgreementHistory> {
    const { data } = await api.get<AffiliateAgreementHistory>(
      affiliatePath(slug, id, '/agreement'),
    );
    return data;
  },

  /** `GET …/affiliates/{id}/referrals?status=` — `status` is sent only when set. */
  async listAffiliateReferrals(
    slug: string,
    id: number,
    query?: AffiliateReferralQuery,
  ): Promise<AffiliateReferralList> {
    const { data } = await api.get<AffiliateReferralList>(affiliatePath(slug, id, '/referrals'), {
      params: compactParams(query),
    });
    return data;
  },

  /** `GET …/affiliates/{id}/codes`. */
  async listAffiliateCodes(slug: string, id: number): Promise<AffiliateCodeList> {
    const { data } = await api.get<AffiliateCodeList>(affiliatePath(slug, id, '/codes'));
    return data;
  },

  /** `POST …/affiliates/{id}/pause` — from `ACTIVE` only; otherwise 409 `AFFILIATE_STATE`. */
  async pauseAffiliate(slug: string, id: number): Promise<AffiliateDetail> {
    const { data } = await api.post<AffiliateDetail>(affiliatePath(slug, id, '/pause'));
    return data;
  },

  /** `POST …/affiliates/{id}/resume` — from `PAUSED` only; otherwise 409 `AFFILIATE_STATE`. */
  async resumeAffiliate(slug: string, id: number): Promise<AffiliateDetail> {
    const { data } = await api.post<AffiliateDetail>(affiliatePath(slug, id, '/resume'));
    return data;
  },

  /**
   * `POST …/affiliates/{id}/end` — from `ACTIVE` or `PAUSED`, with a reason. For cause: earning
   * stops and unpaid statements are held. Otherwise 409 `AFFILIATE_STATE`.
   */
  async endAffiliate(
    slug: string,
    id: number,
    body: AffiliateCauseRequest,
  ): Promise<AffiliateDetail> {
    const { data } = await api.post<AffiliateDetail>(affiliatePath(slug, id, '/end'), body);
    return data;
  },

  /** `POST …/affiliates/{id}/release-hold` — the only way to lift the review hold. */
  async releaseAffiliateHold(
    slug: string,
    id: number,
    body: AffiliateCauseRequest,
  ): Promise<AffiliateDetail> {
    const { data } = await api.post<AffiliateDetail>(
      affiliatePath(slug, id, '/release-hold'),
      body,
    );
    return data;
  },

  /** `GET /v1/admin/resellers/{resellerId}/affiliates` — read-only, no plan query. */
  async listResellerAffiliates(resellerId: number): Promise<ResellerAffiliateList> {
    const { data } = await api.get<ResellerAffiliateList>(resellerPath(resellerId, '/affiliates'));
    return data;
  },

  /** `POST …/addons/{id}/charges/{chargeId}/waive`. */
  async waiveAddonCharge(
    slug: string,
    id: number,
    chargeId: number,
    body: AddonWaiveRequest,
  ): Promise<ChargeView> {
    const { data } = await api.post<ChargeView>(
      tenantPath(
        slug,
        `/addons/${encodeURIComponent(String(id))}/charges/${encodeURIComponent(String(chargeId))}/waive`,
      ),
      body,
    );
    return data;
  },

  // ----- The partner ledger (TMMPDM-0095; TMMAPI-0162 U3/U4, at spec 5199620f) -----

  /** `GET …/partners/{payeeRef}/ledger` — the balance, open holds and last statement. */
  async getPartnerLedger(payeeRef: string): Promise<PartnerLedgerView> {
    const { data } = await api.get<PartnerLedgerView>(ledgerPath(payeeRef));
    return data;
  },

  /** `GET …/ledger/statements` — newest first; `afterId` pages. */
  async listLedgerStatements(payeeRef: string, afterId?: string): Promise<LedgerStatementPage> {
    const { data } = await api.get<LedgerStatementPage>(ledgerPath(payeeRef, '/statements'), {
      params: compactParams({ afterId }),
    });
    return data;
  },

  /** `GET …/ledger/statements/{statementId}`. */
  async getLedgerStatement(payeeRef: string, statementId: string): Promise<LedgerStatementView> {
    const { data } = await api.get<LedgerStatementView>(
      ledgerPath(payeeRef, `/statements/${encodeURIComponent(statementId)}`),
    );
    return data;
  },

  /** `GET …/ledger/statements/{statementId}/lines` — `afterId` pages. */
  async listLedgerStatementLines(
    payeeRef: string,
    statementId: string,
    afterId?: string,
  ): Promise<LedgerLinePage> {
    const { data } = await api.get<LedgerLinePage>(
      ledgerPath(payeeRef, `/statements/${encodeURIComponent(statementId)}/lines`),
      { params: compactParams({ afterId }) },
    );
    return data;
  },

  /** `GET …/ledger/lines?unassigned=true` — the lines no statement has taken yet. */
  async listUnassignedLedgerLines(payeeRef: string, afterId?: string): Promise<LedgerLinePage> {
    const { data } = await api.get<LedgerLinePage>(ledgerPath(payeeRef, '/lines'), {
      params: compactParams({ unassigned: 'true', afterId }),
    });
    return data;
  },

  /** `POST …/ledger/holds {reason}` — a FOR_CAUSE hold, one open per payee (audited). */
  async openLedgerHold(payeeRef: string, body: LedgerHoldRequest): Promise<void> {
    await api.post(ledgerPath(payeeRef, '/holds'), body);
  },

  /** `POST …/ledger/holds/{holdId}/release {reason}` — 409 `HOLD_OPS_ONLY` is relayed as sent. */
  async releaseLedgerHold(
    payeeRef: string,
    holdId: string,
    body: LedgerHoldRequest,
  ): Promise<void> {
    await api.post(ledgerPath(payeeRef, `/holds/${encodeURIComponent(holdId)}/release`), body);
  },

  /** `POST …/ledger/holds/{holdId}/void {reason, confirmation}` — FOR_CAUSE only. */
  async voidLedgerHold(payeeRef: string, holdId: string, body: LedgerVoidRequest): Promise<void> {
    await api.post(ledgerPath(payeeRef, `/holds/${encodeURIComponent(holdId)}/void`), body);
  },

  /** `POST …/ledger/manual-payments` — tmm-api checks the bound; the console sends what was typed. */
  async recordLedgerManualPayment(
    payeeRef: string,
    body: LedgerManualPaymentRequest,
  ): Promise<void> {
    await api.post(ledgerPath(payeeRef, '/manual-payments'), body);
  },

  /** `POST …/ledger/adjustments` — a signed `ADJUSTMENT`, with the sign the person chose. */
  async postLedgerAdjustment(payeeRef: string, body: LedgerAdjustmentRequest): Promise<void> {
    await api.post(ledgerPath(payeeRef, '/adjustments'), body);
  },

  /** `GET /v1/admin/billing/ledger/cutover` — the readiness read (item 26). */
  async getLedgerCutover(): Promise<LedgerCutoverView> {
    const { data } = await api.get<LedgerCutoverView>(`${CUTOVER_PATH}/cutover`);
    return data;
  },

  /** `POST …/ledger/a2-confirmation` — sets `billing.ledger_a2_confirmed` (audited). */
  async confirmLedgerA2(): Promise<void> {
    await api.post(`${CUTOVER_PATH}/a2-confirmation`);
  },

  /** `POST …/ledger/live-verticals-confirmation` — sets `billing.ledger_live_verticals_confirmed`. */
  async confirmLedgerLiveVerticals(): Promise<void> {
    await api.post(`${CUTOVER_PATH}/live-verticals-confirmation`);
  },

  /** `POST …/ledger/freeze` — stops tmm's payout machinery; nothing deleted; idempotent. */
  async freezeLedgerPayouts(): Promise<void> {
    await api.post(`${CUTOVER_PATH}/freeze`);
  },

  /**
   * `POST …/ledger/opening` — a dry run by default; `confirm: true` posts it.
   * YAML `LedgerOpeningRequest.confirm` is an optional boolean (missing is false). This call
   * still sends `{}` or `{ confirm: true }`, never null.
   */
  async ledgerOpening(confirm: boolean): Promise<LedgerOpeningView> {
    const { data } = await api.post<LedgerOpeningView>(
      `${CUTOVER_PATH}/opening`,
      confirm ? { confirm: true } : {},
    );
    return data;
  },

  // ----- Tickets (TMMPDM-0109; TMMAPI-0181 U5, YAML at 3a2d9f5f). Every action is audited by tmm-api. -----

  /**
   * `GET /v1/admin/tickets?type&status&tenant&q&from&page&size` — one server page, newest first.
   * `from` is sent only for a created range; "Any time" sends no date.
   */
  async listTickets(q: TicketListQuery, opts?: RequestOptions): Promise<TicketPage> {
    const { data } = await api.get<TicketPage>('/v1/admin/tickets', {
      params: compactParams(q),
      ...signalOf(opts),
    });
    return data;
  },

  /** `GET /v1/admin/tickets/{number}` — every update, public and internal. 404 `TICKET_NOT_FOUND`. */
  async getTicket(number: number): Promise<TicketView> {
    const { data } = await api.get<TicketView>(ticketPath(number));
    return data;
  },

  /**
   * `POST …/tickets/{number}/updates {visibility, body}` — `PUBLIC` emails the member; `INTERNAL`
   * never does. The caller re-reads the ticket.
   */
  async postTicketUpdate(number: number, body: TicketUpdateRequest): Promise<void> {
    await api.post(ticketPath(number, '/updates'), body);
  },

  /** `POST …/tickets/{number}/status {status}` — 409 when the type doesn't allow it from the current one. */
  async changeTicketStatus(number: number, body: TicketStatusRequest): Promise<void> {
    await api.post(ticketPath(number, '/status'), body);
  },

  /** `POST …/tickets/{number}/duplicate {duplicateOf}` — the canonical ticket gains a follower. */
  async markTicketDuplicate(number: number, body: TicketDuplicateRequest): Promise<void> {
    await api.post(ticketPath(number, '/duplicate'), body);
  },

  /** `POST …/tickets/{number}/shipped-in {shippedIn}` — free text; an empty string clears it. */
  async setTicketShippedIn(number: number, body: TicketShippedInRequest): Promise<void> {
    await api.post(ticketPath(number, '/shipped-in'), body);
  },

  /**
   * `GET …/tickets/{number}/attachments/{id}` (TMMPDM-0110; 0181 U7 item 46, audited) — the file as a
   * blob, through this client (bearer-protected, never a bare link). The caller saves it; nothing
   * renders it. 404 when the file is gone.
   */
  async downloadTicketAttachment(number: number, attachmentId: number): Promise<Blob> {
    const { data } = await api.get<Blob>(
      ticketPath(number, `/attachments/${encodeURIComponent(String(attachmentId))}`),
      { responseType: 'blob' },
    );
    return data;
  },

  // ----- Announcements (TMMPDM-0110; TMMAPI-0181 U5, YAML at 3a2d9f5f). Audited by tmm-api. -----

  /** `GET /v1/admin/announcements?state&kind&page&size` — one server page, newest first, with read counts. */
  async listAnnouncements(
    q: AnnouncementListQuery,
    opts?: RequestOptions,
  ): Promise<AnnouncementPage> {
    const { data } = await api.get<AnnouncementPage>(ANNOUNCEMENTS_PATH, {
      params: compactParams(q),
      ...signalOf(opts),
    });
    return data;
  },

  /** `GET /v1/admin/announcements/{id}` — the announcement and its body. */
  async getAnnouncement(id: number): Promise<AnnouncementView> {
    const { data } = await api.get<AnnouncementView>(announcementPath(id));
    return data;
  },

  /** `POST /v1/admin/announcements` — a new draft. */
  async createAnnouncement(body: AnnouncementWrite): Promise<AnnouncementView> {
    const { data } = await api.post<AnnouncementView>(ANNOUNCEMENTS_PATH, body);
    return data;
  },

  /**
   * `PUT /v1/admin/announcements/{id}` — a draft's fields, replaced. 409 `ANNOUNCEMENT_NOT_DRAFT` once it
   * isn't a draft (a scheduled one is unpublished first).
   */
  async updateAnnouncement(id: number, body: AnnouncementWrite): Promise<AnnouncementView> {
    const { data } = await api.put<AnnouncementView>(announcementPath(id), body);
    return data;
  },

  /**
   * `POST …/announcements/{id}/publish {publishAt?}` — now without a date, else scheduled. The leak
   * guard runs here: 422 `ANNOUNCEMENT_TERM_REFUSED {term}`; 409 `ANNOUNCEMENT_NOT_DRAFT` once it isn't a draft.
   */
  async publishAnnouncement(
    id: number,
    body: AnnouncementPublishRequest,
  ): Promise<AnnouncementView> {
    const { data } = await api.post<AnnouncementView>(announcementPath(id, '/publish'), body);
    return data;
  },

  /** `POST …/announcements/{id}/unpublish` — a scheduled, published or expired one goes back to a draft. */
  async unpublishAnnouncement(id: number): Promise<AnnouncementView> {
    const { data } = await api.post<AnnouncementView>(announcementPath(id, '/unpublish'));
    return data;
  },

  /** `POST …/announcements/{id}/expire` — a published one ends now; 409 `ANNOUNCEMENT_NOT_PUBLISHED {state}` otherwise. */
  async expireAnnouncement(id: number): Promise<AnnouncementView> {
    const { data } = await api.post<AnnouncementView>(announcementPath(id, '/expire'));
    return data;
  },

  /** `DELETE /v1/admin/announcements/{id}` — a draft only: 409 `ANNOUNCEMENT_NOT_DRAFT` otherwise. */
  async deleteAnnouncement(id: number): Promise<void> {
    await api.delete(announcementPath(id));
  },

  // ----- Merchant knowledge (TMMPDM-0112; vendored from tmm-api f7c843fb, blob f2a3324a, TMMPDM-0113).
  // Every action is an audited MM-D-101 operation. No route here carries or answers a member, tenant or
  // owner. -----

  /**
   * `GET /v1/admin/merchant-patterns?state&promotable&q&page&size` — one server page of one state;
   * `promotable` (`true` | `false`) is the server's filter, sent only when set.
   */
  async listMerchantPatterns(
    q: MerchantPatternListQuery,
    opts?: RequestOptions,
  ): Promise<MerchantPatternPage> {
    const { data } = await api.get<MerchantPatternPage>('/v1/admin/merchant-patterns', {
      params: compactParams({
        state: q.state,
        ...(q.promotable === undefined ? {} : { promotable: String(q.promotable) }),
        q: q.q,
        page: q.page,
        size: q.size,
      }),
      ...signalOf(opts),
    });
    return data;
  },

  /**
   * `POST …/merchant-patterns/{id}/approve {name?, kind?}` — only an approval promotes a pattern. 409
   * `MERCHANT_PATTERN_NOT_PROMOTABLE {failedGates}` when a recomputed gate fails, 409
   * `MERCHANT_PATTERN_STATE {state}` when it isn't a candidate; the screen re-reads, so the answered row
   * is not returned.
   */
  async approveMerchantPattern(id: number, body: MerchantPatternApproveRequest): Promise<void> {
    await api.post(merchantPatternPath(id, '/approve'), body);
  },

  /** `POST …/merchant-patterns/{id}/reject {reason}` — a candidate only (409 `MERCHANT_PATTERN_STATE {state}`). */
  async rejectMerchantPattern(id: number, body: MerchantPatternRejectRequest): Promise<void> {
    await api.post(merchantPatternPath(id, '/reject'), body);
  },

  /** `POST …/merchant-patterns/{id}/retire` — an approved pattern leaves use (409 `MERCHANT_PATTERN_STATE {state}`). */
  async retireMerchantPattern(id: number): Promise<void> {
    await api.post(merchantPatternPath(id, '/retire'));
  },

  /** `GET /v1/admin/naming-quality?from&to` — counts and the server's rates, read-only. */
  async getNamingQuality(
    q: NamingQualityQuery,
    opts?: RequestOptions,
  ): Promise<NamingQualityReport> {
    const { data } = await api.get<NamingQualityReport>('/v1/admin/naming-quality', {
      params: compactParams(q),
      ...signalOf(opts),
    });
    return data;
  },

  /**
   * `GET /v1/admin/institution-requests` — the bank names members typed that aren't in the catalog,
   * grouped by typed name and country, newest first, at most 200 rows (no paging in v1).
   */
  async listInstitutionRequests(opts?: RequestOptions): Promise<InstitutionRequestList> {
    const { data } = await api.get<InstitutionRequestList>(
      '/v1/admin/institution-requests',
      signalOf(opts),
    );
    return data;
  },

  /**
   * `POST …/institution-requests/{id}/add {name, country, city?, kind}` — creates an `ADMIN` institution,
   * closes the row's open requests and answers the created institution. 409 `INSTITUTION_REQUEST_STATE`
   * when they were already handled.
   */
  async addInstitutionRequest(
    id: number,
    body: InstitutionAddRequest,
  ): Promise<CatalogInstitution> {
    const { data } = await api.post<CatalogInstitution>(institutionRequestPath(id, '/add'), body);
    return data;
  },

  /** `POST …/institution-requests/{id}/dismiss` — closes the row's open requests (204; 409 `INSTITUTION_REQUEST_STATE`). */
  async dismissInstitutionRequest(id: number): Promise<void> {
    await api.post(institutionRequestPath(id, '/dismiss'));
  },
};
